'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ModalDialog", "_contextual", "centered", "contextual", "use", "size", "width"];
import { forwardRef, useContext } from 'react';
import AbstractModal from './internal/AbstractModal';
import ModalTransition from './internal/ModalTransition';
import UIModalDialog from './UIModalDialog';
import { createPlacementWarning, DropdownContext } from '../context/DropdownContext';
import { jsx as _jsx } from "react/jsx-runtime";
const UIModal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      ModalDialog = UIModalDialog,
      _contextual = false,
      centered = false,
      contextual = false,
      use = 'default',
      size = 'auto',
      width = 450
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    shouldLogModalWarning
  } = useContext(DropdownContext);
  const _createPlacementWarning = createPlacementWarning(UIModal.displayName);
  if (shouldLogModalWarning) {
    _createPlacementWarning();
  }
  return /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
    centered: centered,
    contextual: contextual,
    use: use,
    size: size,
    width: width,
    ModalDialog: ModalDialog,
    _contextual: _contextual,
    componentName: "UIModal",
    Transition: ModalTransition,
    ref: ref
  }));
});
UIModal.displayName = 'UIModal';
export default UIModal;